<script lang="ts">
    import DropDownCheveron from '$lib/assets/dropdown-cheveron.svg?raw'
    import { createEventDispatcher } from 'svelte';

    export let currency
    let popUpOpen : boolean = false
    const handleCurrencySelector = () => {
        popUpOpen = !popUpOpen
    }
    const dispatch = createEventDispatcher()

    const setCurrency = (event) => {
        dispatch('notify', {
            currency: event.target.value
        })
    }
</script>

<div class="currency-selector">
    <span class="currenty-selector__trigger" on:click={handleCurrencySelector}>Show salary in: <span>{currency}</span> {@html DropDownCheveron}</span>
    <div class="selection-popup" class:show-pop-up={popUpOpen}>
        <label class="selection-popup__input"><input type="radio" class="input-radio" value="ZAR" name="currency" checked on:click={setCurrency}/> ZAR (South African Rand)</label> 
        <label class="selection-popup__input"><input type="radio" class="input-radio" value="EUR" name="currency" on:click={setCurrency}/> Euro (Euro)</label>
    </div>
</div>

<style lang="postcss">

    @import '../../styles/_mixins.css';
    .currency-selector {
        position: relative;

        & .currenty-selector__trigger {
            font-size:14px;
            display: flex;
            gap:5px;
            align-items:center;
            
            & span {
                font-weight:600;
            }

            &:hover {
                cursor: pointer;
            }

            @mixin screen-sm {
                margin:24px 0 0;
                font-size:16px;
            }
        }
        & .selection-popup {
            display: none;
            flex-direction: column;
            position: absolute;
            background-color:var(--color_white);
            font-size:16px;
            padding:20px 0 20px 20px;
            width: 245px;
            border: 1px solid rgb(228, 235, 239);
            box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 5px;
            z-index:999;
            left:-90px;
            top:25px;

            & .selection-popup__input {
                margin: 0 0 12px;
            }

            @mixin screen-sm {
                left:0;
                top:50px;
                padding:20px 20px 12px;
                width:100%;
            }
        }

        & .show-pop-up {
            display: block;
        }
    }

    .selection-popup__input {
        display: flex;
        align-items: center;
        gap:8px;
        cursor: pointer;

        & .input-radio {
            -webkit-appearance: none;
            appearance: none;
            background-color: #fff;
            margin: 0;
            font: inherit;
            color: var(--color_offerzen_cerulean_secondary);
            width: 20px;
            height: 20px;
            border: 1px solid;
            border-color: var(--color_grey_secondary);
            border-radius: 50%;
            background-color:transparent;
            display: grid;
            place-content: center;
            cursor: pointer;

            @mixin screen-md {
                height:30px;
                width:30px;
            }

            &::before {
                content: "";
                width: 12px;
                height:12px;
                border-radius: 50%;
                transform: scale(0);
                transition: 0ms transform ease-in-out;
                box-shadow: inset 1em 1em var(--color_offerzen_cerulean_secondary);
                background-color: var(--color_offerzen_cerulean_secondary);

                @mixin screen-md {
                    height:20px;
                    width:20px;
                }

            }

            &:checked::before {
                transform: scale(1);
            }

            &:checked {
                background-color:var(--color_offerzen_lightblue_secondary);
            }

            &:focus {
                border:solid 1px var(--color_offerzen_cerulean_secondary);
            }
        }

        & .error {
            border-color: var(--color_offerzen_error);
        }
    }
</style>
